import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ApiResponse } from '@app/shared/interfaces';
import { ReservationService } from '@app/shared/services/reservation/reservation.service';

export interface ExtendGracePeriodDialogData {
  paymentUuid: string;
  reservationUuid: string;
  code: string;
}

@Component({
  standalone: false,
  selector: 'sbnb-dialog-extend-grace-period',
  templateUrl: './dialog-extend-grace-period.component.html',
  styleUrls: ['./dialog-extend-grace-period.component.scss'],
})
export class DialogExtendGracePeriodComponent implements OnInit {
  date: string;
  dialogData: ExtendGracePeriodDialogData;
  isLoading = false;

  constructor(
    private reservationService: ReservationService,
    public dialogRef: MatDialogRef<DialogExtendGracePeriodComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExtendGracePeriodDialogData
  ) {
    this.dialogData = data;
  }

  ngOnInit() { }

  onDatesSelected(date) {
    this.date = date;
  }

  onSave() {
    this.isLoading = true;

    this.reservationService
      .extendPaymentGracePeriod(this.dialogData.reservationUuid, this.dialogData.paymentUuid, this.date)
      .subscribe((res: ApiResponse<{ new_grace_period_end: string }>) => {
        this.isLoading = false;
        if (res && res.data && res.data.new_grace_period_end) {
          this.dialogRef.close(res?.data?.new_grace_period_end);
        }
      });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
